import { linkHandler }           from 'Utils';
import React                     from 'react';
import { useSelector }           from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isUserLoggedIn }        from 'Redux/Queries';
import { IRoute }                from 'Config/Routes';

export const IsUserLoggedIn = () => {
  const location = useLocation();
  const { pathname } = location;
  const isLoggedIn = useSelector(isUserLoggedIn);

  if (!isLoggedIn && linkHandler.getPrivateRoutes().map((route: IRoute) => route.path).includes(pathname)) {
    return <Navigate to={linkHandler.get('login')}/>;
  }

  if (!isLoggedIn || (isLoggedIn && pathname !== linkHandler.get('login'))) {
    return null;
  }
  // return <Navigate to={linkHandler.get('home')}/>;
};
